import {Epic} from 'redux-observable';
import {TopNavBarButtonID} from 'module/TopNavBar/enum/TopNavBarButtonEnums';
import {setTopNavBarButtonAction} from 'module/TopNavBar/action/TopNavBarAction';
import {personSetSingleChoiceModeAction, personVisibleChangedAction} from 'module/Person/action/PersonAction';
import {filter, map} from 'rxjs/operators'
import {selPersonFilterActive} from 'module/Person/selector/PersonSelector'
import {isAnyOf} from 'util/redux'
import {AppName, getAppName} from 'util/AppName'

// no "active" color for old apps with multi person selection
const filterActiveColor = getAppName() === AppName.onClient || getAppName() === AppName.resourceCalendar ? undefined : 'secondary'

export const TopNavBarPersonButtonColorByVisibilityEpic: Epic = (action$, state$) => action$.pipe(
	filter(isAnyOf(personVisibleChangedAction, personSetSingleChoiceModeAction)),
	map(() => selPersonFilterActive(state$.value) ?
		setTopNavBarButtonAction({name: TopNavBarButtonID.Person, backgroundColor: filterActiveColor})
		:
		setTopNavBarButtonAction({name: TopNavBarButtonID.Person, color: null, backgroundColor: null}),
	),
)